// @ts-check
/** Not-loaded error. */
export default class NotLoadedError extends Error {}
